// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__5SuVO","description":"MealItem_description__Mvxx3","price":"MealItem_price__ntvcP"};